<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form ref="ff" size="small" inline :model="queryParams">
        <el-form-item>
          <metaPicker type="report-type" :value.sync="queryParams.type" clearable placeholder="报告类型" />
          <el-date-picker id="datePicker" v-model="queryParams.firstdate" :type="queryParams.type" :format="queryParams.type == 'month'
    ? 'yyyy年MM月'
    : queryParams.type == 'week'
      ? 'yyyy第WW周'
      : 'yyyy年MM月dd日'
    " value-format="yyyy-MM-dd" placeholder="选择日期" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable placeholder="员工姓名" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button @click="onForm()">工作总结</el-button>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%" border>
      <el-table-column label="报告类型" width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-link type="primary" :underline="false" @click="onReport(row)">
            {{ row.Code }}
            <el-tag v-if="row.Reviews > 0" effect="dark" size="mini">
              批示{{ row.Reviews }}次
            </el-tag>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="User.Name" label="报告人" width="120" show-overflow-tooltip />
      <el-table-column label="工作总结" min-width="120">
        <template slot-scope="{ row }">
          <span class="text-cut">{{ row.Content }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工作时段" width="190">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.FirstDate) }}
          至{{ $utils.common.parseTime(row.LastDate) }}
        </template>
      </el-table-column>
      <el-table-column label="上报时间" width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.Publish, "{y}-{m}-{d} {h}:{i}") }}
        </template>
      </el-table-column>
      <el-table-column width="60" align="center">
        <template slot-scope="{ row }">
          <el-link class="el-icon-edit" @click="onForm(row)" />
          <el-link type="danger" class="el-icon-delete" @click="onDelete(row)" />
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex"
        :total="datalist.TotalCount" @current-change="onSearch" />
    </div>
  </full-container>
</template>


<script>
import formpage from "./form.vue";
import detailpage from "./detail.vue";
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
  },
  data() {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.report
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onForm(row = {}) {
      this.$layer.iframe({
        title: "工作任务",
        area: ["600px", "auto"],
        content: {
          content: formpage,
          parent: this,
          data: {
            report: row,
          },
        },
      });
    },

    //查看报告
    onReport(row = {}) {
      this.$layer.iframe({
        title: "工作报告",
        area: ["640px", "auto"],
        content: {
          content: detailpage,
          parent: this,
          data: {
            id: row?.Id,
          },
        },
      });
    },
    //删除报告
    onDelete(row) {
      this.$confirm(`此操作将永久删除数据, 是否继续?`, "删除", {
        center: true,
      }).then(() => {
        this.$apis.job.report
          .delete({ id: row.Id })
          .then(() => {
            this.$message({ message: "已删除报告内容", type: "success" });
            this.loadData();
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
  },
};
</script>